import axios from "axios";
import {
  ADMIN_DELETE_POST_FAILURE,
  ADMIN_DELETE_POST_REQUEST,
  ADMIN_DELETE_POST_SUCCESS,
  ADMIN_POST_FAILURE,
  ADMIN_POST_REQUEST,
  ADMIN_POST_SUCCESS,
  DELETE_USER_FAILURE,
  DELETE_USER_REQUEST,
  DELETE_USER_SUCCESS,
  GET_USER_FAILURE,
  GET_USER_REQUEST,
  GET_USER_SUCCESS,
} from "./admin.types";

const token = localStorage.getItem("token");
axios.defaults.headers.common["Authorization"] = token;

export const getUsers = () => async (dispatch) => {
  dispatch({ type: GET_USER_REQUEST });
  try {
    const res = await axios.get(
      `https://mauve-rabbit-gown.cyclic.app/user/all`
    );
    const data = await res.data;
    dispatch({ type: GET_USER_SUCCESS, payload: data });
  } catch (e) {
    dispatch({ type: GET_USER_FAILURE });
  }
};

export const getAllPosts = () => async (dispatch) => {
  dispatch({ type: ADMIN_POST_REQUEST });
  try {
    const res = await axios.get(
      `https://mauve-rabbit-gown.cyclic.app/user/posts`
    );
    const data = await res.data;
    dispatch({ type: ADMIN_POST_SUCCESS, payload: data });
  } catch (e) {
    dispatch({ type: ADMIN_POST_FAILURE });
  }
};

export const deleteUser = (_id) => async (dispatch) => {
  console.log(_id);
  dispatch({ type: DELETE_USER_REQUEST });
  try {
    const res = await axios.delete(
      `https://mauve-rabbit-gown.cyclic.app/user/deleteuser/${_id}`
    );
    const data = await res.data;
    dispatch({ type: DELETE_USER_SUCCESS, payload: data });
    return getUsers();
  } catch (e) {
    dispatch({ type: DELETE_USER_FAILURE });
  }
};

export const deletePost = (_id) => async (dispatch) => {
  console.log(_id);
  dispatch({ type: ADMIN_DELETE_POST_REQUEST });
  try {
    const res = await axios.delete(
      `https://mauve-rabbit-gown.cyclic.app/user/deletepost/${_id}`
    );
    const data = await res.data;
    dispatch({ type: ADMIN_DELETE_POST_SUCCESS, payload: data });
    return getAllPosts();
  } catch (e) {
    dispatch({ type: ADMIN_DELETE_POST_FAILURE });
  }
};
